export default __webpack_public_path__ + "static/media/lions23.f0f197a6.svg";